import { createId } from '../../../shared/util';
import us from '../defines';
import { mountVueComponent } from '../../../shared/components/vue-factory';

/**
 * Creates a viewport "overlay" extension constructor that can be passed to the uScope plugin API.
 * @param components
 * @param layoutOptions
 * @param hiddenNavModes
 * @returns {function(*, *, ...[*]): Vue}
 */
export function makeOverlayExtension ({ components, layoutOptions, hiddenNavModes = {} }) {
  return function (uScope, viewport, ...dependencies) {
    viewport.overLayout.add(layoutOptions);
    const jVpDiv = viewport.vpDivGet('outer');
    const { div, id } = makeDiv(layoutOptions.divClass);
    jVpDiv.append(div);

    mountVueComponent({
      el: `#${id}`,
      components
    },
    Object.values(components)[0],
    {
      viewport,
      dependencies
    });
  };
}

export const makeVisibilityHelper = (userConfig, configKey, viewport, hiddenNavModes = null) => {
  if (!hiddenNavModes) { // set most common nav mode config if not specified
    hiddenNavModes = {};
    us.setAnnotNavModes(hiddenNavModes);
  }

  let onVisibilityChanged = () => {};

  const states = {
    prefIsEnabled: false,
    isViewportSelected: false,
    viewportNavMode: us.eNavModes.nmNone,

    // Computed / getter
    get isVisible () {
      return this.isViewportSelected &&
        this.prefIsEnabled &&
        !hiddenNavModes[this.viewportNavMode];
    }
  };

  const configEvent = `change:${configKey}`;
  const context = Symbol('context');
  const handleConfigChanged = () => {
    states.prefIsEnabled = userConfig.get(configKey);
    onVisibilityChanged(states.isVisible);
  };
  userConfig.onLoad(handleConfigChanged);
  userConfig.events.on(configEvent, handleConfigChanged, context);
  viewport.events.on('viewport:navigation-change', (navMode) => {
    if (states.viewportNavMode !== navMode) { // TODO: Investigate. Shouldn't "navigation-change" only trigger on change?
      states.viewportNavMode = navMode;
      onVisibilityChanged(states.isVisible);
    }
  });

  viewport.events.on('viewport:selected', () => {
    states.isViewportSelected = viewport.isSelected;
    onVisibilityChanged(states.isVisible);
  });

  // Cleanup config event handler when viewport closes
  viewport.events.on('$destroy', () => {
    userConfig.events.off(configEvent, null, context);
  });

  return {
    onVisibilityChanged: (handler) => { onVisibilityChanged = handler; }
  };
};

export function makeDiv (klass) {
  const id = createId();
  const div = document.createElement('div');
  div.setAttribute('id', id);
  if (klass) {
    div.classList.add(klass);
  }
  return { div, id };
}
